<template>
	<div class="container text-center">
			<div class="desc">
				<h3>{{siteCfg ? siteCfg.webtool_login_slogon : 'PC端批量转链工具'}}</h3>
				<p>{{siteCfg ? siteCfg.webtool_login_desc : '满足代理多场景化转链·降本提效'}}</p>
			</div>
			<img class="login-img" :src="siteCfg && siteCfg.webtool_login_img ? siteCfg.webtool_login_img : 'https://img.huajuanyun.com/utools/2023/913/1694590020148.png'" alt="">
		<div class="content">
			<div class="title m-b-10 font18 bold">转链工具网址链接</div>
			<div class="main">
				<div class="text font16">{{ siteCfg ? siteCfg.domain : website }}</div>
				<div class="text-center btn font16" @click="handleCopy">复制链接</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
import { setTitle, setHeader } from '@/utils/index'
export default {
	data () {
		return {
			website: ''
		}
	},
	computed: {
		siteCfg() {
			return this.$store.getters.config
		}
	},
	mounted() {
		this.DS.call('DS.setClipBoardEnabled', '0') // 禁止监听app剪切板
		this.website = `http://${window.xid}.webtool.hndhsoft.cn`
		setHeader({
			showHeader: 1,
			titleName: this.siteCfg ? this.siteCfg.webtool_login_slogon : 'PC端批量转链工具'
		})
	},
	methods: {
		handleCopy() {
			this.DS.call('DS.copyToClipboard', this.siteCfg ? this.siteCfg.domain : this.website)
			this.DS.call('DS.showToast', '链接已复制')
		}
	},
}
</script>

<style scoped lang="scss">
.container {
	min-height: 100vh;
	max-width: 750px;
	padding: 50px 20px 20px;
	background-image: radial-gradient(100% 157.26% at 0 0,rgba(217,242,255,.32) 0,rgba(242,240,252,.32) 27.87%,rgba(191,216,255,.32) 100%);
	box-sizing: border-box;
	.logo {
		width: 120px;
		margin: 0 auto;
		display: block;
	}
	.desc {
		font-size: 16px;
		color: #666666;
		text-align: center;
		h3{
			font-size: 30px;
			margin-bottom: 5px;
			color: #111111;
		}
	}
	.login-img {
		width: 100%;
		display: block;
		margin: 0 auto;
	}
	.content {
		width: 100%;
		padding: 15px;
		background: #fff;
		border-radius: 10px;
		.main {
			padding: 20px;
			background: #f8f8f8;
			border-radius: 10px;
			box-shadow: 0 0 3px 0 generate-transparent-background(0.1) inset;
			.text {
				white-space: pre-wrap;
    			word-break: break-all;
			}
			.btn {
				width: 180px;
				height: 40px;
				line-height: 40px;
				margin: 20px auto 0;
				color: #fff;
				background: $primary-color;
				border-radius: 50px;
				cursor: pointer;
			}
		}
	}
}
</style>
